export default __webpack_public_path__ + "static/media/epifania.af8727ec.jpg";